export const hasClass = (elem: any, cls: string) => {
  if (!elem) return;
  cls = cls || "";
  if (cls.replace(/\s/g, "").length === 0) return false; // 当cls没有参数时，返回false
  return new RegExp(" " + cls + " ").test(" " + elem.className + " ");
};

export const addClass = (elem: any, cls: string) => {
  if (!elem) return;
  if (!hasClass(elem, cls)) {
    elem.className = elem.className === "" ? cls : elem.className + " " + cls;
  }
};

export const removeClass = (elem: any, cls: string) => {
  if (!elem) return;
  if (hasClass(elem, cls)) {
    let newClass = " " + elem.className.replace(/[\t\r\n]/g, "") + " ";
    while (newClass.indexOf(" " + cls + " ") >= 0) {
      newClass = newClass.replace(" " + cls + " ", " ");
    }
    elem.className = newClass.replace(/^\s+|\s+$/g, "");
  }
};
